function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiddletext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 895.29 89.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 895.29,
    height: 89.18,
    style: {
      fill: "#1650a0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.3,51.74c0,4.42-1.5,7.82-4.51,10.18s-7.38,3.54-13.11,3.54H6V18.24h16.82c5.03,0,8.98,1.07,11.85,3.22s4.32,5.09,4.32,8.83c0,4.55-2.27,7.92-6.8,10.11,3.05.77,5.33,2.2,6.85,4.27s2.27,4.43,2.27,7.07ZM12.25,38.01h10.5c3.46,0,6-.55,7.63-1.66s2.45-2.95,2.45-5.52c0-2.32-.79-4.07-2.38-5.23s-4.35-1.76-8.28-1.76h-9.92v14.17ZM12.25,59.85h11.37c7.47,0,11.21-2.71,11.21-8.12,0-2.81-.86-4.87-2.59-6.17s-4.87-1.95-9.42-1.95h-10.57v16.24Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.52,66.26c-5.48,0-9.57-1.06-12.29-3.19s-4.43-4.63-5.15-7.51-1.08-6.22-1.08-10.02v-27.32h6.25v27.22c0,6.21,1.04,10.29,3.12,12.24s5.13,2.93,9.15,2.93,7.07-.98,9.15-2.93,3.12-6.03,3.12-12.24v-27.22h6.28v27.32c0,5.71-.68,9.92-2.05,12.63s-3.42,4.73-6.17,6.07c-2.75,1.34-6.2,2.01-10.34,2.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.46,66.26c-6.66,0-11.63-1.49-14.93-4.48-3.3-2.99-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5c-5.4-1.15-9.28-2.74-11.63-4.78-2.35-2.04-3.53-4.76-3.53-8.15,0-3.82,1.53-6.96,4.59-9.41,3.06-2.45,7.12-3.67,12.19-3.67,5.33,0,9.62,1.23,12.89,3.7,3.26,2.47,4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87c4.2.92,7.53,1.84,10,2.74s4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.7,65.46h-6.28V18.24h6.28v47.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.05,65.46h-6.41l-24.74-37.27v37.27h-5.93V18.24h6.38l24.74,37.27V18.24h5.96v47.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.83,65.46h-35.21V18.24h34.11v5.61h-27.86v14.43h26.06v5.61h-26.06v15.98h28.96v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.44,66.26c-6.66,0-11.63-1.49-14.93-4.48s-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5c-5.4-1.15-9.28-2.74-11.63-4.78s-3.53-4.76-3.53-8.15c0-3.82,1.53-6.96,4.59-9.41,3.06-2.45,7.12-3.67,12.19-3.67,5.33,0,9.62,1.23,12.89,3.7,3.26,2.47,4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87c4.2.92,7.53,1.84,10,2.74s4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.44,66.26c-6.66,0-11.63-1.49-14.93-4.48-3.3-2.99-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5c-5.4-1.15-9.28-2.74-11.63-4.78-2.35-2.04-3.53-4.76-3.53-8.15,0-3.82,1.53-6.96,4.59-9.41,3.06-2.45,7.12-3.67,12.19-3.67,5.33,0,9.62,1.23,12.89,3.7,3.26,2.47,4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87c4.2.92,7.53,1.84,10,2.74s4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.97,66.26c-6.66,0-11.63-1.49-14.93-4.48-3.3-2.99-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67s-6.02-2.35-11.42-3.5c-5.4-1.15-9.28-2.74-11.63-4.78s-3.53-4.76-3.53-8.15c0-3.82,1.53-6.96,4.59-9.41,3.06-2.45,7.12-3.67,12.19-3.67,5.33,0,9.62,1.23,12.89,3.7s4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87c4.2.92,7.53,1.84,10,2.74s4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.61,17.43c6.61,0,12.03,2.23,16.24,6.7s6.31,10.37,6.31,17.72-2.11,13.25-6.31,17.72-9.62,6.7-16.24,6.7-12.07-2.24-16.3-6.72-6.35-10.38-6.35-17.7,2.11-13.25,6.35-17.72,9.66-6.7,16.3-6.7ZM421.55,60.92c4.72,0,8.6-1.68,11.61-5.03s4.53-8.03,4.53-14.04-1.5-10.69-4.51-14.04-6.84-5.03-11.5-5.03-8.64,1.68-11.68,5.03c-3.04,3.35-4.56,8.03-4.56,14.04s1.51,10.67,4.54,14.03,6.88,5.04,11.56,5.04Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.69,65.46h-29.22V18.24h6.25v41.62h22.97v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.69,66.26c-5.48,0-9.57-1.06-12.29-3.19s-4.43-4.63-5.15-7.51-1.08-6.22-1.08-10.02v-27.32h6.25v27.22c0,6.21,1.04,10.29,3.12,12.24,2.08,1.96,5.13,2.93,9.15,2.93s7.07-.98,9.15-2.93,3.12-6.03,3.12-12.24v-27.22h6.28v27.32c0,5.71-.68,9.92-2.05,12.63s-3.42,4.73-6.17,6.07-6.2,2.01-10.34,2.01Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.37,23.84h-15.62v41.62h-6.28V23.84h-15.49v-5.61h37.4v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.16,65.46h-6.28V18.24h6.28v47.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.89,17.43c6.61,0,12.03,2.23,16.24,6.7,4.21,4.47,6.31,10.37,6.31,17.72s-2.11,13.25-6.31,17.72c-4.21,4.47-9.62,6.7-16.24,6.7s-12.07-2.24-16.3-6.72-6.35-10.38-6.35-17.7,2.11-13.25,6.35-17.72,9.66-6.7,16.3-6.7ZM615.83,60.92c4.72,0,8.6-1.68,11.61-5.03,3.02-3.35,4.53-8.03,4.53-14.04s-1.5-10.69-4.51-14.04c-3.01-3.35-6.84-5.03-11.5-5.03s-8.64,1.68-11.68,5.03c-3.04,3.35-4.56,8.03-4.56,14.04s1.51,10.67,4.54,14.03c3.03,3.36,6.88,5.04,11.56,5.04Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.83,65.46h-6.41l-24.74-37.27v37.27h-5.93V18.24h6.38l24.74,37.27V18.24h5.96v47.22Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.21,66.26c-6.66,0-11.63-1.49-14.93-4.48-3.3-2.99-5.03-6.82-5.2-11.5h6.02c.32,3.52,1.79,6.13,4.4,7.81s5.76,2.53,9.45,2.53c3.5,0,6.32-.72,8.46-2.16s3.21-3.39,3.21-5.86c0-2.6-1.11-4.49-3.32-5.67-2.21-1.18-6.02-2.35-11.42-3.5-5.4-1.15-9.28-2.74-11.63-4.78s-3.53-4.76-3.53-8.15c0-3.82,1.53-6.96,4.59-9.41,3.06-2.45,7.12-3.67,12.19-3.67,5.33,0,9.62,1.23,12.89,3.7s4.99,5.96,5.19,10.47h-6.09c-.62-5.71-4.53-8.57-11.73-8.57-3.48,0-6.17.65-8.09,1.97s-2.87,3.05-2.87,5.22c0,1.97.77,3.46,2.3,4.45s4.4,1.94,8.6,2.87c4.2.92,7.53,1.84,10,2.74s4.59,2.3,6.35,4.2,2.64,4.45,2.64,7.65c0,4.06-1.62,7.43-4.85,10.11s-7.45,4.03-12.64,4.03Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.47,65.46h-29.22V18.24h6.25v41.62h22.97v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.16,65.46h-29.22V18.24h6.25v41.62h22.97v5.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.41,66.26c-6.68,0-12.01-2.2-15.99-6.59-3.98-4.39-5.98-10.33-5.98-17.83s1.99-13.44,5.98-17.83c3.98-4.39,9.32-6.59,15.99-6.59,5.13,0,9.5,1.39,13.11,4.16s5.64,6.42,6.09,10.95h-6.44c-.26-2.99-1.55-5.36-3.88-7.12-2.33-1.76-5.27-2.64-8.81-2.64-4.79,0-8.58,1.65-11.37,4.94-2.79,3.3-4.19,8-4.19,14.13s1.39,10.8,4.16,14.11,6.53,4.96,11.27,4.96c3.69,0,6.68-.9,8.96-2.71,2.28-1.8,3.57-4.38,3.87-7.73h6.44c-.45,5.03-2.43,8.91-5.93,11.66-3.5,2.75-7.92,4.12-13.27,4.12Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "748.12 58.86 741.04 58.86 737.84 74.77 740.75 74.77 748.12 58.86",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddletext);
export default __webpack_public_path__ + "static/media/middletext.d6f6a2aa5b52d931326b5bd65ffde392.svg";
export { ForwardRef as ReactComponent };